import { createContext } from "react";

export const BatchModalContext = createContext();
